<script>
import { ref, onMounted, computed } from '@vue/composition-api';
import { useStore } from '@vueblocks/vue-use-vuex';
import { useRoute, useRouter } from 'vue2-helpers/vue-router';
import { UserService } from '@/common/api.service.js'
import AppContainer from '@/components/uikit/Layout/AppContainer.vue';
import UiLoader from '@/components/uikit/UiLoader'

export default {
  components: {
    AppContainer,
    UiLoader,
  },
  setup () {
    const route = useRoute();
    const router = useRouter();
    const { dispatch } = useStore();

    const isLoading = ref(true)
    const ssoResult = ref()
    const errorText = ref('')

    const isErrorText = computed(() => !!errorText.value?.length)

    const checkSSO = async () => {
      const {
        code = '',
        session_state: sessionState = '',
        state = '',
      } = route?.query ?? {};
      const authErrorText = 'An authorization error occurred.'
      const params = {
        code,
        session_state: sessionState,
        state,
      }

      try {
        if (
          !code?.length ||
          !sessionState?.length ||
          !state?.length
        ) {
          throw new Error()
        }

        ssoResult.value = await UserService.checkSso(params)

        const { token = {}, error = '' } = ssoResult?.value?.data ?? {}

        if (
          error?.length ||
          !Object.keys(token)?.length
        ) {
          throw new Error()
        }

        handleLogin(token)
      } catch (error) {
        errorText.value = authErrorText
        isLoading.value = false
      }
    }

    const handleLogin = async (token) => {
      await dispatch('AUTH_SSO_LOGIN', {
        token,
      })

      router.push({ name: 'home' })
    }

    onMounted(() => {
      checkSSO()
    })

    return {
      isLoading,
      isErrorText,
      errorText,
    }
  },
}
</script>

<template>
  <AppContainer>
    <UiLoader v-if="isLoading"/>
    <div
      v-else
      :class="$style.Content"
    >
      <div v-if="isErrorText">{{ $t(errorText) }}</div>
    </div>
  </AppContainer>
</template>

<style lang="scss" module>
@import './SsoView.module.scss';
</style>
